export default __webpack_public_path__ + "img/d61089fbd90f8aaa0b5329a51936a2d7.png";